<template>
  <div
    class="d-flex flex-column min-vh-100 vh-100"
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />

    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <ActivationPendingPage
            v-if="displayActivationStatus"
            v-bind:process="activationProcess"
            @resendMail="resendActivationMail"
            @login-again="displayActivationStatus = false"
          ></ActivationPendingPage>

          <v-snackbar v-model="snackbar">
            An activation E-Mail has been sent to your account

            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
          <section v-if="!displayActivationStatus" class="page-section">
            <div class="container">
              <v-card class="mx-auto my-12" max-width="374">
                <form @submit.prevent="handleSubmit">
                  <v-card-title>
                    Login
                  </v-card-title>
                  <v-card-text>
                    <div class="form-group">
                      <label for="username">Username</label>
                      <input
                        type="text"
                        v-model="username"
                        name="username"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && !username }"
                      />
                      <div
                        v-show="submitted && !username"
                        class="invalid-feedback"
                      >
                        Username is required
                      </div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        v-model="password"
                        name="password"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && !password }"
                      />
                      <div
                        v-show="submitted && !password"
                        class="invalid-feedback"
                      >
                        Password is required
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <button
                      class="btn btn-primary w-75"
                      style="margin:auto"
                      :disabled="status.loggingIn"
                    >
                      Login
                    </button>
                    <img
                      v-show="status.loggingIn"
                      src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                    />
                  </v-card-actions>
                  <v-card-text style="text-align:center">
                    <div>
                      Don't have an account?
                      <router-link to="/register" class="btn btn-link"
                        >Sign Up</router-link
                      >
                    </div>
                    <div>
                      <router-link to="/newPassword" class="btn btn-link"
                        >Forgot your password?</router-link
                      >
                    </div>
                    <div>
                      <router-link to="/forgotUsername" class="btn btn-link"
                        >Forgot your username?</router-link
                      >
                    </div>
                  </v-card-text>
                </form>
              </v-card>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";
import ActivationPendingPage from "@/views/user_management/ActivationPendingPage";

export default {
  components: { ActivationPendingPage, NavigationMain },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      displayActivationStatus: false,
      snackbar: false,
      activationProcess: [false, false]
    };
  },
  computed: {
    ...mapState("api", ["status"])
  },
  created() {
    // reset login status
    console.log("created!");
    this.logout();
  },
  methods: {
    ...mapActions("api", [
      "login",
      "logout",
      "handleRequestError",
      "printAlertMessage",
      "resendActivation"
    ]),
    resendActivationMail() {
      this.resendActivation(this.username).then(() => {
        console.log("int then ewnr ");
        this.snackbar = true;
      });
    },
    reset() {
      this.username = "";
      this.password = "";
      this.submitted = false;
    },
    handleSubmit(e) {
      this.submitted = true;
      const { username, password } = this;
      if (username && password) {
        const target = this.$route?.query?.target;
        this.login({
          username,
          password,
          target,
          errorHandler: err => {
            if ("data" in err) {
              if ("process" in err.data) {
                // User not activated
                this.activationProcess = err.data.process;
                console.log(err.data);
                this.displayActivationStatus = true;
              } else {
                this.handleRequestError(err);
                this.password = "";
              }
            }
          }
        });
      }
    }
  }
};
</script>
